import { BodyText, Card, Icon } from '@postscript/components';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  align-items: flex-start;
  border: 1px solid var(--border-color-dim);
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  padding: var(--spacing-3);
  transition: var(--hover-transition);

  &:hover,
  &:focus {
    border-color: var(--highlight-color);
  }
`;

interface MoreOptionsCardProps {
  testId: string;
  description: string;
  icon: () => JSX.Element;
  onClick: () => void;
  title: string;
}

export default function MoreOptionsCard({
  testId,
  description,
  icon,
  onClick,
  title,
}: MoreOptionsCardProps) {
  return (
    <StyledCard
      data-cy={testId}
      data-testid={testId}
      onClick={onClick}
      size="small"
    >
      <Icon component={icon} size={24} color="var(--gray-9)" />
      <BodyText size="x-small" bold color="var(--text-color-dim)">
        {title}
      </BodyText>
      <BodyText color="var(--text-color-dim)" size="x-small">
        {description}
      </BodyText>
    </StyledCard>
  );
}
